import React from 'react';
import styled, { css } from 'styled-components';
import { Link } from 'react-router-dom';

interface ButtonProps {
  className?: string;
  label: string;
  link: string;
  external?: boolean;
}
const StyledLink = styled(Link)`
  display: inline-flex;
  border: 1px solid var(--color-button-border-secondary);
  border-radius: var(--border-radius-m);
  padding: var(--distance-3xs) var(--distance-s);
  box-sizing: border-box;
  text-decoration: none;
  line-height: var(--line-height-xxs);
  cursor: pointer;
  text-transform: uppercase;
  font-size: var(--font-size-xs);
  font-family: var(--font-family-camel);
  background-color: var(--color-button-background-secondary);
  color: var(--color-button-text-secondary);

  &:focus {
    background-color: var(--color-button-background-focus-secondary);
    color: var(--color-button-text-secondary);
    border: 1px solid var(--color-button-border-focus-secondary);
    outline: 2px solid var(--color-button-outline-secondary);
  }

  &:hover {
    background-color: var(--color-button-background-hover-secondary);
    color: var(--color-button-text-secondary);
    border: 1px solid var(--color-button-border-hover-secondary);
  }
`;

const ButtonAsLink = ({ 
  className,
  label,
  link,
  external = true
} : ButtonProps) => (
  <StyledLink className={className} to={link} rel={external ? "nofollow" : undefined}>
    {label}
  </StyledLink>
);

export default ButtonAsLink;
